// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__VoPVa","backdrop_over":"Backdrop_backdrop_over__2RzdT"};